var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportBage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 34,
    viewBox: "0 0 49 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0682,
    cy: 18.9354,
    r: 15.0682,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7846 27.8344C11.4665 27.8344 11.1607 27.7488 10.8792 27.5653C10.3287 27.2104 10.0351 26.5987 10.1085 25.9502L10.3532 24.066C8.70146 22.7202 7.72266 20.7259 7.72266 18.6338C7.72266 16.248 8.97062 14.0212 11.0628 12.6876C12.323 11.8679 13.8156 11.4275 15.3694 11.4275C19.5905 11.4275 23.0162 14.6574 23.0162 18.6338C23.0162 20.2488 22.4289 21.8393 21.3523 23.0995C19.9697 24.7757 17.9021 25.7544 15.6264 25.8279L12.6411 27.6019C12.3719 27.761 12.0783 27.8344 11.7846 27.8344ZM15.3572 13.2627C14.1582 13.2627 13.0081 13.593 12.0416 14.2292C10.4755 15.2325 9.54566 16.8719 9.54566 18.6338C9.54566 20.3344 10.3776 21.8883 11.8458 22.8915C12.1272 23.0873 12.274 23.4176 12.2373 23.7602L11.9682 25.8523L14.8923 24.115C15.0391 24.0294 15.1982 23.9804 15.3572 23.9804C17.1557 23.9804 18.8564 23.2096 19.933 21.9005C20.7405 20.9462 21.1688 19.8205 21.1688 18.6215C21.1688 15.6729 18.5627 13.2627 15.3572 13.2627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportBage);
export default __webpack_public_path__ + "static/media/support-bage.332d332740bf894ceb01d31237d705d4.svg";
export { ForwardRef as ReactComponent };